import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, Spinner } from 'react-bootstrap';
import NavAnalista from 'components/NavAnalista';
import StatusAnalista from 'components/StatusAnalista';
import MasterPage from 'components/MasterPage';
import { api } from 'services';
import { DashboardOutlined } from '@material-ui/icons';
import ActionsAnalista from 'components/ActionsAnalista';
import PlansAnalista from 'components/PlansAnalista';
import collect from 'collect.js';
import { useSelector } from 'react-redux';
import Can from 'components/Can';
import './style.css';
import Chart from 'react-apexcharts';

var categoriesArr = [];
var vendorsArr = {};

const DashboardAnalista = () => {
  const [categories, setCategories] = useState([]);
  const [reports, setReports] = useState([]);
  const [companies, setCompanies] = useState({ data: [] });
  const [users, setUsers] = useState({ data: [] });
  const [user, setUser] = useState(null);
  const [fiscalYear, setFiscalYear] = useState("2022");
  const { t } = useTranslation();
  const profile = useSelector(state => state.user.profiles ? state.user.profiles[0].profile_type_id : null);

  const [info, setInfo] = useState({});
  const [countActions, setCountActions] = useState({});
  const [countMarketingPlan, setCountMarketingPlan] = useState({})
  const [infoFund, setInfoFunds] = useState({})
  const [infoActions, setInfoActions] = useState({})
  const [infoCategories, setInfoCategories] = useState({
    labels: [],
    series: []
  })
  const [infoVendors, setInfoVendors] = useState({ 
    name: [],
    value: []
  })
  const [loading, setLoading] = useState(false)

  const [countPlan, setCountPlan] = useState(0);

  const getPlansByActualPeriod = (companies) => {
    let count = 0;
    companies.forEach((a, k) => {
      if (Object.values(a.actual_period).length > 0 && a.actual_period.period) {
        let period = a.actual_period.period.id;
        let countPlans = a.marketing_plan.filter((b) => {
          return b.company_rule && b.company_rule.id == period && b.status_id != 5;
        }).length;
        if (countPlans == 0) {
          count += 1;
        }
      }
    });
    return count;
  };

  useEffect(() => {
    api.get('users/with-profile').then(({ data }) => {
      setUsers(data);
    });
  },[])

  useEffect(() => {
    setLoading(true)
    getMarketingPlansCount()
    getInfoFunds()
    getActionsCount()
    getVendors()
    getCategories()
    getInfoActions()
  }, [user, fiscalYear]);
  
  const getCountByPlans = async () => {
    return await api.get('companies/count-by-plans', {
      params: { ...{ profile_type_id: profile, user_id: user, fiscal_year: fiscalYear  } },
    })
    .then(({ data }) => {
      setCompanies(data.data);
      setCountPlan(getPlansByActualPeriod(data.data));
    })
  }

  const getActionsCount = () => {
    api.get('/dashboard/actions-count', {
      params: { 
        profile_type_id: profile, 
        user_id: user, 
        fiscal_year: fiscalYear 
      }
    }).then(({ data }) => {
      setCountActions(data)
    })
  }

  const getMarketingPlansCount = () => {
    api.get('/dashboard/marketing-plans-count', {
      params: { 
        profile_type_id: profile, 
        user_id: user, 
        fiscal_year: fiscalYear 
      }
    }).then(({ data }) => {
      setCountMarketingPlan(data)
    })
  }

  const getInfoFunds = () => {
    api.get('/dashboard/info-funds', {
      params: { 
        profile_type_id: profile, 
        user_id: user, 
        fiscal_year: fiscalYear 
      }
    }).then(({ data }) => {
      setInfoFunds(data)
    })
  }

  const getCategories = () => {
    api.get('/dashboard/get-categories', {
      params: { 
        profile_type_id: profile, 
        user_id: user, 
        fiscal_year: fiscalYear 
      }
    }).then(async ({ data }) => {
      var series = []
      var labels = []

      await Promise.resolve()
      .then(() => {
        data.forEach(item => {
          series.push(item.value)
          labels.push(item.categorieName)
        })
      })
      setInfoCategories({ series, labels })
    })
  }

  const getInfoActions = () => {
    api.get('/dashboard/info-actions', {
      params: { 
        profile_type_id: profile, 
        user_id: user, 
        fiscal_year: fiscalYear 
      }
    })
    .then(({ data }) => {
      setInfoActions(data)
    })
    .finally(() => setLoading(false))
    
  }

  const getVendors = () => {
    api.get('/dashboard/get-vendors', {
      params: { 
        profile_type_id: profile, 
        user_id: user, 
        fiscal_year: fiscalYear 
      }
    }).then(({ data }) => {
      setInfoVendors(data)
    })
  }

  const spent = (actions) => {
    let countSpent = 0;
    actions.map((action) => {
      action.all_values.map(
        (value) => {
          let cotacao = value.fund ? parseFloat(value.fund.value_cotacao) : 1;
          countSpent += parseFloat(value.actual_value) * cotacao;
        }
      );
    });
    return countSpent;
  };

  const refunds = (actions) => {
    let countSpent = 0;
    actions.map((action) => {
      action.refunds.map((value) => {
        countSpent += parseFloat(value.value) * action.med_cotacao;
      });
    });
    return countSpent;
  };

  const createCategories = () => {
    categoriesArr = [];
    let cat = collect(categories).groupBy('task.name').map(function (a) {
      return a.sum('value_in_real');
    });
    cat.map((c, n) => {
      let obj = { value: c, categorieName: n }
      categoriesArr.push(obj);
    });
  };

  const createVendors = () => {
    vendorsArr = { value: [], name: [] };

    reports.map((report) => {
      vendorsArr.name.push(report.alias);
      let count = 0;
      report.actions.map((action) => {
        action.all_values.map((value) => {
          let cotacao = value.fund ? value.fund.value_cotacao : 1;
          count += value.actual_value * cotacao;
        });
      });
      vendorsArr.value.push(count);
    });
  };

  const handleChangeUser = (user_id) => {
    setInfo({});
    setUser(user_id);
  }

  const handleFiscalYear = (fiscal_year) => {
    setFiscalYear(fiscal_year)
  }

  const categorieGraphic = () => {
    return <Chart
      options={{
        labels: infoCategories.labels.length > 0 ? infoCategories.labels : [],
        legend: {
          show: false,
          position: 'bottom',
          offsetY: 100,
        },
        title: {
          text: t('label:activity'),
          align: 'center',
          floating: false,
        },
        chart: {
          width: '100%',
          height: '50%'
        },
        tooltip: {
          y: {
            formatter: function (d) {
              return d
                ? 'R$ ' +
                d.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
                : '';
            },
          },
        },
        dataLabels: {
          enabled: false
        },
        colors: [
          '#58DB51',
          '#D61A26',
          '#048DD6',
          '#0FD6B1',
          '#feb019',
          '#0A5D8A',
          '#038A70',
        ]
      }}
      series={infoCategories.series.length > 0 ? infoCategories.series : []}
      type="donut"
    />;
  };

  const vendorGraphic = () => {
    return <Chart
      options={{
        labels: infoVendors.name.length > 0 ? infoVendors.name : [],
        legend: {
          show: false,
          position: 'bottom',
          offsetY: 100,
        },
        title: {
          text: t('label:company'),
          align: 'center',
          floating: false,
        },
        chart: {
          width: '100%',
          height: '50%'
        },
        tooltip: {
          y: {
            formatter: function (d) {
              return d
                ? 'R$ ' +
                d.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
                : '';
            },
          },
        },
        dataLabels: {
          enabled: false
        }
      }}
      series={ infoVendors.value.length ? infoVendors.value : []}
      type="donut"
    />;
  }

  const BarChartAnalista = ({ count, countSpent, countReceipt, countAR }) => {
    return <Chart
      options={{
        xaxis: {
          categories: [
            'Verba', 'Gasto', 'Recebido', 'Custo'
          ],
        },
        labels: vendorsArr.name,
        tooltip: {
          y: {
            formatter: function (d) {
              return d
                ? 'R$ ' +
                d.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
                : '';
            },
          },
        },
        yaxis: {
          labels: {
            formatter: function (d) {
              return d
                ? 'R$ ' +
                d.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
                : '';
            },
          },
        },
        dataLabels: {
          enabled: false
        }
      }}
      series={[{
        name: 'Valor',
        data: [count, countSpent, countReceipt, countAR]
      }]}
      type='bar'
    />;
  }

  const formatValue = value => value.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})

  return (
    <>
      <Row className="justify-content-between">
        <Col className="d-flex mt-3 mb-3">
          <DashboardOutlined className="icon-title" />
          <h4 className="title-dashboard mt-2">{t('title:dashboard')}</h4>
        </Col>
        <Can do="viewFilterAnalyst" on="App">
          <Col md='auto' className="mt-4">
            <Row className="align-items-center pr-4">
              <label className="col-auto m-0 font-weight-bold">{t('label:analyst')}:</label>
              <select
                className="col-auto select-style"
                value={user}
                onChange={(e) =>
                  handleChangeUser(e.target.value)
                }
              >
                <option value="">{t('label:all')}</option>
                {users.data.filter(user => user.profiles[0].name == "Analista").map((option, k) => (
                  <option key={k} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
            </Row>
          </Col>
        </Can>
        <Col md="2" className="mt-4">
          <Row className="align-items-center pr-4">
            <label className="col-auto m-0 font-weight-bold">Ano Fiscal:</label>
            <select
              className="col-auto select-style"
              value={fiscalYear}
              onChange={(e) => handleFiscalYear(e.target.value)}
            >
              <option value="">{t('label:all')}</option>
              <option>2022</option>
              <option>2021</option>
              <option>2020</option>
              <option>2019</option>              
            </select>
          </Row>
        </Col>
      </Row>
      <Row className="p-1">
        <Col>
          <NavAnalista
            { ...{ loading } }
            countFunds={infoFund.count_value_real_null ?? 0}
            countClaim={countActions.countAwaitingReceipt ?? 0}
            countPlan={countPlan}
            countExecution={countActions.countOnExecution ?? 0}
            countStatus={countActions.countAwaitingComprovations ?? 0}
            countReceipt={countActions.countFinished ?? 0}
          />
        </Col>
      </Row>
      <Row className="p-2">
        <StatusAnalista
          { ...{ loading } }
          fund={infoFund.sum_current_value ?? 0}
          count={infoActions.sumMargin ?? 0}
          countAwaitingComprovations={infoActions.spendCountAwaitingComprovations ?? 0}
          countAR={infoActions.spendCountAR ?? 0}
          countReceipt={infoActions.spendCountReceipt ?? 0}
          countDraft={infoActions.countDraft ?? 0}
          countApproval={infoActions.countApproval ?? 0}
          countDisapprovedComprovations={0}
        />
      </Row>
      <Row className="p-2">
        <Col className="mb-3" md='6'>
          <ActionsAnalista
            {...countActions}
            loading={loading}
          />
          <Card
            className="shadow bg-white rounded mt-4 card-style"
            style={{ height: 'calc(100% - 121px)' }}
          >
            <Card.Header>{t('label:spent')}</Card.Header>
            <Row className="mt-3 ml-2">
              <Col>
                <b>Total: </b>
                {!loading?formatValue(infoActions.countSpent ?? 0):(<Spinner animation="border" style={{ color: '#e05c17' }} size='sm' />)}{' '}
              </Col>
            </Row>
            <hr />
            <Row className="justify-content-around">
              {createCategories()}
              {createVendors()}
              <Col md='6' className="mt-3">
                {categorieGraphic()}
              </Col>
              <Col md='6' className="mt-3">
                {vendorGraphic()}
              </Col>
            </Row>
          </Card>
        </Col>
        <Col className="mb-3" md={6}>
          <PlansAnalista
            {...countMarketingPlan}
            loading={loading}
          />
          <Card
            className="shadow bg-white rounded mt-4 mb-3 card-style"
            style={{ height: 'calc(100% - 121px)' }}
          >
            <Card.Header>Verba x Gasto</Card.Header>
            <BarChartAnalista
              { ...{ loading } }
              count={infoFund.sum_current_value ?? 0}
              countSpent={infoActions.countSpent ?? 0}
              countReceipt={infoActions.countReceipt ?? 0}
              countAR={infoActions.spendCountAR ?? 0}
            />
          </Card>
        </Col>

      </Row>
    </>
  );
};

export default DashboardAnalista;